import {useRouter} from 'next/router';
import type React from 'react';
import type {
  RecruitmentDetailSchedule,
  RecruitmentTag as RecruitmentTagType,
} from '../../../../../core/entities/recruitment/schema';
import {
  ENTRY_BUTTON_ID,
  ENTRY_BUTTON_TEXT_SIZE,
  GradientEntryButton,
} from '../../../../../shared/components/EntryButton/GradientEntryButton';
import {appendQueryParam} from '../../../../../shared/services/appendQueryParam';
import {Schedules} from '../../../../recruitingInfo/components/Container/Presenter/Schedules';
import {
  type RecruitmentType,
  Tags,
} from '../../../../recruitingInfo/components/Container/Presenter/Tags';
import type {RecruitmentDataForSchedule} from '../../ScheduleButton';
import {UpdatedBy} from './UpdatedAt';

type Props = {
  title: string;
  recruitmentType: RecruitmentType;
  targetYear: number;
  groupedJobTypes: Array<{id: number; name: string}>;
  tags: RecruitmentTagType[];
  entryURL?: string;
  schedules?: RecruitmentDetailSchedule[];
  modifiedAt: string;
  recruitmentData: RecruitmentDataForSchedule;
};

export const RecruitmentHeaderPC: React.FC<Props> = ({
  title,
  recruitmentType,
  targetYear,
  groupedJobTypes,
  tags,
  entryURL,
  schedules,
  modifiedAt,
  recruitmentData,
}) => {
  const route = useRouter();
  const entryButtonUrl = entryURL
    ? appendQueryParam(entryURL, 'source_url', route.asPath)
    : '';

  return (
    <div className="flex flex-col bg-white p-24 rounded-16 w-[814px] gap-24">
      <div className="flex flex-col">
        <h1 className="leading font-bold text-xl">{title}</h1>
        <div className="flex justify-start items-start flex-wrap mb-4">
          <Tags
            tags={tags}
            type={recruitmentType}
            targetYear={targetYear}
            groupedJobTypes={groupedJobTypes}
            size="sm"
            isGrayColor
          />
        </div>
        <div className="flex justify-between gap-8">
          <UpdatedBy updatedAt={modifiedAt} />
          {entryButtonUrl && (
            <div className="flex justify-end flex-wrap mb-4">
              <GradientEntryButton
                entryUrl={entryButtonUrl}
                id={ENTRY_BUTTON_ID.RECRUITING_INFO}
                size={ENTRY_BUTTON_TEXT_SIZE.BASE}
                className="px-24 h-[41px]"
                withShadow
                companyId={recruitmentData.companyId}
                companyName={recruitmentData.companyName}
                entryTitle={title}
                deadline={schedules?.[0]?.entryEnd}
              />
            </div>
          )}
        </div>
      </div>
      {schedules && schedules.length > 0 && (
        <div className="flex flex-col gap-8">
          <Schedules
            schedules={schedules}
            recruitmentData={recruitmentData}
            withCalendar
            withRegisterButton
          />
        </div>
      )}
    </div>
  );
};
